<template>
    <div>
    <div class="columns is-centered is-multiline">
        <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="true"></b-loading>
        <div class="column is-two-thirds">
            <p class="is-size-4 title">Elige como vas a pagar la orden</p>
            <b-field v-if="transferBool" class="m-b-5" message="Te daremos los datos para que hagas el pago por tu cuenta (sujeto a validacion manual).">
                <b-radio
                    v-model="payment.method"
                    type="is-info"
                    @input="paymentChange"
                    native-value="transfer">
                    <strong>Transferencia bancaria.</strong>
                </b-radio>
            </b-field>
            <hr v-if="transferBool">
            <b-field v-if="cashBool" class="m-b-10" message="Te daremos los datos para que hagas el pago por tu cuenta (sujeto a validacion manual).">
                <b-radio
                    v-model="payment.method"
                    type="is-info"
                    @input="paymentChange"
                    native-value="cash">
                    <strong>Pagos presenciales (Abitab, Redpagos)</strong>
                </b-radio>
            </b-field>
            <hr v-if="cashBool">
            <b-field v-if="paypalBool && ppMin < payment.amountUsd" class="m-b-10" message="Tarjetas de credito, debito y dinero de Paypal.">
                <b-radio
                    v-model="payment.method"
                    type="is-info"
                    @input="paymentChange"
                    native-value="pp">
                    <p> 
                        <img height="30px" src="https://traction-prod.ams3.digitaloceanspaces.com/Untitled-2.png" alt="">
                        
                    </p>
                </b-radio>
            </b-field>
            <hr v-if="paypalBool && ppMin < payment.amountUsd">
            <b-field v-if="mpBool && mpMin < payment.amountUsd" class="m-b-10" message="Tarjetas por medio de mercadopago. hasta 12 cuotas sin interés">
                <b-radio
                    v-model="payment.method"
                    type="is-info"
                    @input="paymentChange"
                    native-value="mp">
                    <p> 
                        <img height="30px" src="https://traction-prod.ams3.digitaloceanspaces.com/Untitled-1.png" alt="">
                        <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/Visa-Logo-650x366.png" alt="logo-master">
                        <img width="50px" src="https://traction-prod.ams3.digitaloceanspaces.com/1200px-Mastercard-logo.svg.png" alt="logo-master">
                    </p>
                </b-radio>
            </b-field>
        </div>
    </div>  
        
    <div class="columns is-centered is-multiline">
        <div class="column is-two-thirds m-b-20">
        <p class="heading has-text-centered"> <b>$UY</b> </p>
        <div class="level has-text-centered is-mobile">
            <div class="level-item">
                <div>
                    <p class="heading">Subtotal</p>
                    <p class="">{{payment.orderTotalUy}}</p>
                </div>
            </div>
            
            <div class="level-item">
                <div>
                    <p class="heading">Envio </p>
                    <p class="">{{payment.shipmentTotalUy}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Descuento </p>
                    <p class="">{{payment.discountUy}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading"><strong>Total</strong></p>
                    <p class=""><strong>$UY {{payment.amountUy}}</strong></p>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div v-if="usdReportsBool" class="column is-two-thirds m-b-20">
        <p class="heading has-text-centered"> <b>$USD</b> </p>
        <div class="level has-text-centered is-mobile">
            <div class="level-item">
                <div>
                    <p class="heading">Subotal</p>
                    <p class="">{{payment.orderTotalUsd}}</p>
                </div>
            </div>
            
            <div class="level-item">
                <div>
                    <p class="heading">Envio</p>
                    <p class="">{{payment.shipmentTotalUsd}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading">Descuento</p>
                    <p class="">{{payment.discountUsd}}</p>
                </div>
            </div>
            <div class="level-item">
                <div>
                    <p class="heading"><strong>Total</strong></p>
                    <p class=""><strong>$USD {{payment.amountUsd}}</strong></p>
                </div>
            </div>
        </div>
    </div>      
    </div>

    <div class="columns is-centered is-multiline">

        <MPCardForm
        :amountUy="payment.amountUy"
        @cardProcessed="tokenHandler"
        :mpPubKey="mpPubKey"
        :method="payment.method"
        v-if="payment.method == 'mp'"
        />
        
        <div  v-if="payment.method == 'transfer' || payment.method == 'cash'" class="column is-full has-text-centered">
            <div class="columns is-multiline m-t-30 is-centered">

                <div class="column is-full">
                    <p>Para que podamos enviarte la orden, necesitamos que realices el pago a uno de estos canales. Te haremos saber via email ni bien entre el pago.</p>
                </div>
                
                <div v-for="x in channelsToRender" :key="x.id" class="column is-one-quarter">
                    <p class="has-text-weight-bold">{{x.title}}</p>
                    <p>{{x.dato1}} - {{x.dato2}} - {{x.dato3}} - {{x.dato4}} - {{x.dato5}}</p>
                </div>
            
            </div>
        </div>
        
        <div :style="payment.method == 'pp' ? 'display:block;' : 'display:none;'" id="paypalContainer" class="paypal-buttons column is-full has-text-centered">
            <div v-if="paypalBool" id="paypal-button-container"></div>
        </div>
    </div>
    </div>
</template>

<script>
import { postHandler } from '../../../../services/http'
import MPCardForm from "./MPCardForm.vue"

export default {
    components:{
        MPCardForm
    },
    props:{
        order:{
            type:Object,
            default: new Object({})
        },
        payment:{
            type:Object,
            default: new Object({})
        },
        mpBool:{
            type:Boolean,
            default: false
        },
        cashBool:{
            type:Boolean,
            default: false
        },
        paypalBool:{
            type:Boolean,
            default: false
        },
        transferBool:{
            type:Boolean,
            default: false
        },
        mpPubKey:{
            type:String,
            default:""
        },
        orderPayUrl:{
            type:String,
            default:""
        },
        channels:{
            type:Array,
            default:new Array([])
        },
        mpMinOrder:{
            type:String,
            default:""
        },
        ppMinOrder:{
            type:String,
            default:""
        },
        usdReportsBool:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            mpPayment:{},
            paypalData:{},
            loading:false,
            renderedPaypal:false,
        }
    },
    computed:{
        channelsToRender(){
            return this.channels.filter((element)=>{
                return element.method == this.payment.method
            })
        },
        mpMin(){
            return parseInt(this.mpMinOrder)
        },
        ppMin(){
            return parseInt(this.ppMinOrder)
        }
    },
    methods:{
        async postOrderAndPayment(){
            var success = {
                resource:'notify',
                text:'Listo! Pago creado con exito!'
            }
            var error = {
                resource:'notify',
                text:'No se pudo procesar el pago con esta tarjeta, intenta con otra tarjeta, u otro medio de pago.'
            }
            this.loading = true
            console.log(this.paypalData)
            var reqData = {order:this.order, payment:this.payment, mpPayment:this.mpPayment, paypalData:this.paypalData}
            var response = await postHandler(this.orderPayUrl, reqData, {error, success})
            this.loading=false
            this.order = response.data.order
            this.$emit('newData', response.data)
            
        },
        tokenHandler(data){
            this.mpPayment.cardToken = data.token
            this.mpPayment.paymentMethodMpId = data.cardCompanyId
            this.mpPayment.mpInstallments = data.mpInstallments
            this.postOrderAndPayment()
        },
        paymentChange(){
            this.$emit("newData", {payment:this.payment, order:this.order})
        },

        renderPaypal(){
            var total = this.payment.amountUsd.toString()
            var self = this
            if(this.paypalBool){
                this.renderedPaypal = true
                paypal.Buttons({
                    createOrder(data, actions){
                        return actions.order.create({
                            purchase_units: [{
                            amount: {
                                currency_code: "USD",
                                value: total
                            }
                            }]
                        });
                    },
                    onApprove: (data, actions)=>{
                        // This function captures the funds from the transaction.
                        return actions.order.capture().then(function(details) {
                            if(details.status == 'COMPLETED'){
                                self.paypalData = {
                                    paypalId:details.id,
                                    status:details.status,
                                    payerEmail:details.payer.email_address,
                                    firstName:details.payer.name.given_name,
                                    lastName:details.payer.name.surname,
                                }
                                self.postOrderAndPayment()
                            }
                        });
                        }
                }).render('#paypal-button-container');
            }
        },
    },
    mounted(){
        this.renderPaypal()
    },
}
</script>

<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}

.paypal-buttons{
    position: relative; 
    z-index: 1;
}
</style>